<template>
  <div class="card-input">
    <div class="credit-debit">CREDIT / DEBIT</div>
    <label class="label" for="card-expiry">{{
      $t("checkout.cardNumber")
    }}</label>
    <div
      id="card-number-element"
      class="field"
      style="margin-bottom: 10px"
    ></div>
    <div
      v-if="errorCard"
      id="card-errors"
      class="error-message tooltip"
      role="alert"
    >
      {{ errorCard }}
    </div>
    <div class="input-container">
      <div
        class="input-container"
        style="flex-direction: column; width: 100%; margin-right: 10px"
      >
        <label class="label" for="card-expiry">{{
          $t("checkout.expDate")
        }}</label>
        <div id="card-expiry-element" class="field"></div>
      </div>
      <div class="input-container" style="flex-direction: column; width: 100%">
        <label class="label" for="card-expiry">{{ $t("checkout.cvc") }}</label>
        <div id="card-cvc-element" class="field"></div>
      </div>
    </div>
    <div
      v-if="error"
      id="card-errors"
      class="error-message-date tooltipDate"
      role="alert"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StripeCardInput",
  props: {
    stripe: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    cardNumberElement: null,
    cardExpiryElement: null,
    cardCvcElement: null,
    isCompleteCardNumberElement: null,
    isCompleteCardExpiryElement: null,
    isCompleteCardCvcElement: null,
    error: null,
    errorCard: null,
    errorDate: null,
  }),
  computed: {
    stripeElements() {
      return this.stripe.elements();
    },
  },
  mounted() {
    // Create Card Number Element
    this.cardNumberElement = this.stripeElements.create("cardNumber");
    this.cardNumberElement.mount("#card-number-element");

    // Create Card Expiry Element
    this.cardExpiryElement = this.stripeElements.create("cardExpiry");
    this.cardExpiryElement.mount("#card-expiry-element");

    // Create Card CVC Element
    this.cardCvcElement = this.stripeElements.create("cardCvc");
    this.cardCvcElement.mount("#card-cvc-element");

    this.$store.dispatch("checkout/setCardInputElement", {
      cardNumberElement: this.cardNumberElement,
      cardExpiryElement: this.cardExpiryElement,
      cardCvcElement: this.cardCvcElement,
    });

    this.cardNumberElement.on("change", ({ error, complete }) => {
      if (error) {
        this.errorCard = error.message;
      } else {
        this.errorCard = null;
      }
      const isCompleted = !!(
        complete &&
        this.isCompleteCardCvcElement &&
        this.isCompleteCardExpiryElement
      );
      this.handleElementChange(error, isCompleted);
      if (complete) {
        this.isCompleteCardNumberElement = true;
        this.cardExpiryElement.focus();
      }
    });

    this.cardExpiryElement.on("change", ({ error, complete }) => {
      if (error) {
        this.error = error.message;
      } else {
        this.error = null;
      }
      const isCompleted = !!(
        complete &&
        this.isCompleteCardCvcElement &&
        this.isCompleteCardNumberElement
      );
      this.handleElementChange(error, isCompleted);
      if (complete) {
        this.isCompleteCardExpiryElement = true;
        this.cardCvcElement.focus();
      }
    });

    this.cardCvcElement.on("change", ({ error, complete }) => {
      console.log({ error, complete });
      const isCompleted = !!(
        complete &&
        this.isCompleteCardNumberElement &&
        this.isCompleteCardExpiryElement
      );
      this.handleElementChange(error, isCompleted);
      if (complete) {
        this.isCompleteCardCvcElement = true;
        // Optionally, you can move the focus to the next input field or perform any other action here.
      }
    });
  },
  beforeDestroy() {
    this.cardNumberElement.destroy();
    this.cardExpiryElement.destroy();
    this.cardCvcElement.destroy();
  },
  methods: {
    handleElementChange(error, isCompleted) {
      console.log(isCompleted);
      if (error) {
        this.$emit("handleError", { value: false });
      } else {
        if (isCompleted) {
          console.log("Completed");
          this.$emit("handleCompleteCard");
        } else {
          this.$emit("handleError", { value: false });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-input {
  /*border: 1px solid #ccc;*/
  border-radius: 5px;
  background: linear-gradient(to bottom, var(--v-primary-base), #000000);
  padding: 50px 20px 10px 20px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.input-container {
  margin-bottom: 10px;
  display: flex;
  /*align-items: center; !* Align items horizontally *!*/
}

.label {
  font-weight: bold;
  margin-bottom: 5px;
  color: white;
  text-align: left;
}
.credit-debit {
  position: absolute; /* Added */
  top: 20px; /* Adjust as needed */
  right: 20px; /* Adjust as needed */
  font-size: 14px; /* Adjust as needed */
  color: white; /* Adjust as needed */
}

.field {
  background-color: #fff;
  font-size: 16px;
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
}
.input-container.inline {
  display: flex;
  align-items: center;
}

.input-container.inline .field {
  flex: 1;
  margin-right: 10px;
}

.error-message {
  color: #ff0000;
  //max-width: 160px;
  //background-color: #ffffff;
  //padding: 10px;
  //margin-top: 2px;mar
  margin-bottom: 10px;
}
.error-message-date {
  color: #ff0000;
  //max-width: 220px;
  //padding-left: 10px;
  margin-top: -8px;
  margin-bottom: 10px;
}
.tooltip {
  position: absolute;
  background-color: #f5970f;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  //border: 6px solid transparent;
  //border-top-color: #ff0000;
  left: 50%;
  bottom: 60px;
  transform: translateX(-50%);
}
.tooltipDate {
  position: absolute;
  background-color: #f5970f;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  bottom: -20px;
}
</style>
